import React, { useState } from "react";
import axios from "axios";

function ChangePassword() {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [adminData, setAdminData] = useState(null); // store full admin info

    const adminId = localStorage.getItem("adminId");
    const token = localStorage.getItem("token");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!oldPassword || !newPassword || !confirmPassword) {
            setMessage("❌ All fields are required.");
            return;
        }

        if (newPassword !== confirmPassword) {
            setMessage("❌ New password and confirm password do not match.");
            return;
        }

        if (!adminId) {
            setMessage("❌ Admin ID missing. Please log in again.");
            return;
        }

        setLoading(true);
        setMessage("");

        try {
            const response = await axios.put(
                "https://visitguru.in/api/v1/admin/pass",
                { adminId, oldPassword, newPassword },
                {
                    headers: {
                        "Content-Type": "application/json",
                        ...(token && { Authorization: `Bearer ${token}` }),
                    },
                }
            );

            if (response.data.success) {
                setMessage("✅ " + response.data.message);
                setOldPassword("");
                setNewPassword("");
                setConfirmPassword("");
                setAdminData(response.data.admin || null); // save full admin details
            } else {
                setMessage("❌ " + response.data.message);
            }
        } catch (error) {
            setMessage(
                "❌ " +
                (error.response?.data?.message ||
                    "Something went wrong. Please try again.")
            );
        }

        setLoading(false);
    };

    return (
        <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            <div className="rounded-t bg-white mb-0 px-6 py-6">
                <div className="text-center flex justify-between">
                    <h6 className="text-blueGray-700 text-xl font-bold">
                        Change Password
                    </h6>
                </div>
            </div>

            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-wrap">
                        <div className="w-full lg:w-12/12 px-4">
                            {/* Old Password */}
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
                                    Old Password
                                </label>
                                <input
                                    type="password"
                                    className="border-0 px-3 py-3 mt-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    placeholder="Enter Old Password"
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                />
                            </div>

                            {/* New Password */}
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
                                    New Password
                                </label>
                                <input
                                    type="password"
                                    className="border-0 px-3 py-3 mt-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    placeholder="Enter New Password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                            </div>

                            {/* Confirm New Password */}
                            <div className="relative w-full mb-3">
                                <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
                                    Confirm New Password
                                </label>
                                <input
                                    type="password"
                                    className="border-0 px-3 py-3 mt-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    placeholder="Confirm New Password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Show API Response */}
                    {message && (
                        <p
                            className={`mt-3 text-sm ${message.startsWith("✅") ? "text-green-600" : "text-red-600"
                                }`}
                        >
                            {message}
                        </p>
                    )}

                    {/* Show Admin Data */}
                    {adminData && (
                        <div className="mt-4 p-3 bg-white shadow rounded text-sm">
                            <h4 className="font-bold mb-2">Admin Details</h4>
                            <p><b>Name:</b> {adminData.name}</p>
                            <p><b>Email:</b> {adminData.email}</p>
                            <p><b>Mobile:</b> {adminData.mobile}</p>
                            <p><b>Role:</b> {adminData.role}</p>
                        </div>
                    )}

                    <div className="flex justify-end w-full">
                        <button
                            className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs mt-4 px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150 disabled:opacity-50"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? "Updating..." : "Update Password"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ChangePassword;
